let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6hHYZ")).then(() => parcelRequire('8JpVG'));